<template>
  <div class="max-w-sm mx-auto">
    <form class="bg-white shadow-lg rounded px-4 pt-4 pb-8 m-2 border border-gray-200">
      <p class="text-center font-display text-xl text-pink-400 mb-6">Login</p>
      <div class="mb-4">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="email">Email</label>
        <input
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          id="email"
          type="email"
          v-model="email"
        />
      </div>
      <div class="mb-6">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="password">Password</label>
        <input
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
          id="password"
          type="password"
          v-model="password"
        />
      </div>
      <div class="text-right">
        <button
          class="bg-teal-400 hover:bg-teal-500 text-white py-2 px-4 rounded focus:outline-none"
          @click="signInUser"
          type="button"
        >Sign In</button>
      </div>
    </form>
    <div class="text-center">
      <router-link class="text-xs text-gray-500" to="/register">Register</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "login",
  data() {
    return {
      email: null,
      password: null
    };
  },
  methods: {
    signInUser() {
      this.$store.dispatch("signInUser", {
        email: this.email,
        password: this.password
      });
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    }
  },
  watch: {
    user(value) {
      if (value !== null || value !== undefined) {
        this.$router.push("/");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>